export default __webpack_public_path__ + "static/media/009-fishing boat.b3815b88.svg";